export default __webpack_public_path__ + "static/media/certification5.c2bf4350.jpg";